<template>
  <vue-lazy-component
    v-loading="loading"
    element-loading-text="加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :style="style"
    @init="handleFetchData"
  >
    <template v-if="chart === 'VeFunnel'">
      <component
        v-if="chartProps.data.rows"
        :id="id"
        :is="chart"
        :name="chartProps.name"
        :width="width"
        :height="height"
        :data="chartProps.data"
        :extend="chartProps.extend"
      ></component>
    </template>
    <template v-else>
      <component
        @chartClick="chartClickFunc"
        :id="id"
        v-if="option.data"
        :is="chart"
        :name="name"
        :width="width"
        :height="height"
        :option="option"
      ></component>
    </template>
  </vue-lazy-component>
</template>
<script>
import ChartPie from '@/components/echarts/pie'
import ChartBar from '@/components/echarts/bar'
import ChartLine from '@/components/echarts/line'
import Chartradar from '@/components/echarts/newradar'
import simple from '@/components/echarts/simple'
import ChartChinaMap from '@/components/echarts/chinaMap'
import chinaMapbaidu from '@/components/echarts/chinaMapbaidu'
import sanjiPic from '@/components/echarts/sanjiPic'
// import VeFunnel from 'v-charts/lib/funnel.common'
export default {
  components: {
    simple,
    ChartPie,
    ChartBar,
    ChartLine,
    Chartradar,
    ChartChinaMap,
    chinaMapbaidu,
    sanjiPic
    // VeFunnel
  },
  props: ['id', 'name', 'chart', 'fetchConfig', 'option', 'width', 'height', 'chartProps'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    style () {
      const chartProps = this.chartProps || this
      const { width, height } = chartProps
      return {
        width,
        height,
        'min-width': '1px',
        'min-height': '1px'
      }
    }
  },
  methods: {
    chartClickFunc (item) {
      this.$emit('barClick', item)
    },
    handleFetchData (force) {
      const chartProps = this.chartProps || {}
      const option = this.option || chartProps.option || chartProps.data
      const config = this.fetchConfig
      if (force || (config && !option.data)) {
        // 清原来的数据
        this.setChartData(null)
        this.loading = true
        if (config.serviceType) {
          this.$service[config.code](config.data).then((res) => {
            this.loading = false
            this.setChartData(res)
          }).catch(() => {
            this.loading = false
          })
        } else {
          this.$service.macroindexSilent({
            code: config.code
          }).then((res) => {
            if (config.code === 'E-05-03-01') {
              this.$emit('barClick', {
                name: res.xData[0]
              })
            }
            this.loading = false
            this.setChartData(res)
          }).catch(() => {
            this.loading = false
          })
        }
      }
    },
    setChartData (data) {
      const chartProps = this.chartProps || {}
      const option = this.option || chartProps.option || chartProps.data
      const config = this.fetchConfig
      if (config.chartType === 'echarts') {
        option.data = data
      } else {
        // v-charts
        option.rows = data
      }
    }
  },
  created () {
  }
}
</script>
<style lang="stylus" scoped>

</style>
